import moment from "moment-timezone";
import { Link } from "react-router-dom";
import { routes } from "pages/routes";
import {
  Notification,
  deleteNotifications,
  isHighSeverityNotification,
} from "services/notifications";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface TaskListItemProps {
  item: Notification;
  closeDetails: () => void;
  refresh: () => void;
}

export function NotificationListItem({ item, closeDetails, refresh }: TaskListItemProps) {
  const { t } = useTranslation();
  const [isDeleting, setIsDeleting] = useState(false);
  const teamId = item.target_user.team?.id;
  const deleteNotification = () => {
    setIsDeleting(true);
    deleteNotifications(
      { notifications: [item.id] },
      () => {
        refresh();
      },
      () => {
        refresh();
      }
    );
  };
  return (
    <div
      className={
        "notification-list-item" + (isHighSeverityNotification(item) ? " overdue" : "")
      }
    >
      <div className="item-header">
        {item.title}
        <span>•</span>
        {moment.utc(item.created_at).fromNow()}
        <button
          className="item-header-close"
          onClick={deleteNotification}
          disabled={isDeleting}
        >
          &#10006;
        </button>
      </div>
      <div className="item-title">{item.message}</div>
      <div className="actions">
        {teamId && (
          <Link
            className="btn"
            onClick={closeDetails}
            to={routes.teamMemberDetails.path({
              id: teamId,
              member_id: item.target_user.id,
            })}
          >
            {t("Common.pageHeader.viewProfile")}
          </Link>
        )}
      </div>
    </div>
  );
}
